export const TOP_NEW_ORDER = 'top_new'

// Kept in sync with TopWindow::WINDOWS on the backend and TOP_WINDOW_OPTIONS in
// streamOrderMapping. Duplicated here (three tokens) so this leaf module stays
// import-free for its non-React callers.
const STANDARD_TOP_ORDERS = ['upvote', 'upvalue']
const TOP_WINDOWS = ['1h', '24h', 'week', 'month', 'year']

type QuestFilter = Record<string, unknown>

function currentUserCanTopNew(): boolean {
    try {
        const activeGon =
            typeof window !== 'undefined' ? window.gon : typeof gon !== 'undefined' ? gon : null
        return activeGon?.currentUser?.can_top_new ?? false
    } catch {
        return false
    }
}

function currentUserSpaceOrder(): string | null {
    try {
        const activeGon =
            typeof window !== 'undefined' ? window.gon : typeof gon !== 'undefined' ? gon : null
        const order = activeGon?.currentUser?.space_options?.filter?.order
        return typeof order === 'string' && order ? order : null
    } catch {
        return null
    }
}

function currentUserSpaceTopWindow(): string | null {
    try {
        const activeGon =
            typeof window !== 'undefined' ? window.gon : typeof gon !== 'undefined' ? gon : null
        const topWindow = activeGon?.currentUser?.space_options?.filter?.top_window
        return typeof topWindow === 'string' && TOP_WINDOWS.includes(topWindow) ? topWindow : null
    } catch {
        return null
    }
}

function defaultQuestOrder(filter: QuestFilter): string | null {
    if (filter.order || filter.query || filter.ids || filter.questId) return null
    if (filter.ordinals || filter.user_ordinals) return null
    if (
        filter.notifications ||
        filter.history ||
        filter.starred ||
        filter.people ||
        filter.participants ||
        filter.streams ||
        filter.memes
    ) {
        return null
    }

    const savedOrder = currentUserSpaceOrder()
    if (savedOrder && (savedOrder !== TOP_NEW_ORDER || currentUserCanTopNew())) {
        return savedOrder
    }

    return 'time'
}

export function canonicalizeQuestFilter<T extends QuestFilter | null | undefined>(filter: T): T {
    if (!filter) return filter
    const order = defaultQuestOrder(filter)
    if (!order) return filter

    const canonical: QuestFilter = { ...filter, order }
    // A defaulted Top order carries the saved time window with it — the saved
    // space filter stores them as a pair, and Top 24h without its window would
    // silently widen to all time.
    if (
        STANDARD_TOP_ORDERS.includes(order) &&
        canonical.top_window == null &&
        currentUserSpaceOrder() === order
    ) {
        const savedWindow = currentUserSpaceTopWindow()
        if (savedWindow) canonical.top_window = savedWindow
    }
    return canonical as T
}
